import React from "react"
import { Polygon, Circle, Polyline } from "react-leaflet"

import { getLatLongFormat } from "../../../helpers/shapeHelper"
import { ShapeFeatureType, ShapeType } from "../../../types/shape"
import { getCoordinatesFromGeoJSON } from "../../../helpers/geoJSONHelper"

export interface ShapeFeaturePropsType {
  shapeFeature: ShapeFeatureType
  shapeFeatureProps: any
  inscribedPolygon?: ShapeType
}

const ShapeFeature = (props: ShapeFeaturePropsType) => {
  const { shapeFeature, shapeFeatureProps, inscribedPolygon } = props

  let renderedShape
  if (
    shapeFeature &&
    shapeFeature.geometry &&
    shapeFeature.geometry.coordinates
  ) {
    const latLongCoords = getLatLongFormat(
      getCoordinatesFromGeoJSON(shapeFeature)
    )

    console.log("shapeFeature.geometry.type", shapeFeature.geometry.type)
    switch (shapeFeature.geometry.type as any) {
      case "MultiPolygon":
        renderedShape = (
          <Polygon {...shapeFeatureProps} positions={latLongCoords} />
        )
        break
      case "Polygon":
        renderedShape = (
          <>
            {!inscribedPolygon && (
              <Polygon {...shapeFeatureProps} positions={latLongCoords} />
            )}
          </>
        )
        break
      case "LineString":
        renderedShape = (
          <Polyline {...shapeFeatureProps} positions={latLongCoords} />
        )
        break
      case "Point":
        renderedShape = (
          <>
            <Circle
              {...shapeFeatureProps}
              center={latLongCoords[0]}
              radius={
                (shapeFeature.properties && shapeFeature.properties.radius) ||
                200
              }
            />
            {inscribedPolygon && (
              <Polygon
                {...shapeFeatureProps}
                key={`${shapeFeatureProps.key}-polygon`}
                color="#ffbb00"
                positions={inscribedPolygon.layer}
              />
            )}
          </>
        )
        break
      case "multipolygon":
        renderedShape = (
          <Polygon {...shapeFeatureProps} positions={latLongCoords} />
        )
        break
      case "polygon":
        renderedShape = (
          <>
            {!inscribedPolygon && (
              <Polygon {...shapeFeatureProps} positions={latLongCoords} />
            )}
          </>
        )
        break
      case "linestring":
        renderedShape = (
          <Polyline {...shapeFeatureProps} positions={latLongCoords} />
        )
        break
      case "point":
        renderedShape = (
          <>
            <Circle
              {...shapeFeatureProps}
              center={latLongCoords[0]}
              radius={
                (shapeFeature.properties && shapeFeature.properties.radius) ||
                200
              }
            />
            {inscribedPolygon && (
              <Polygon
                {...shapeFeatureProps}
                key={`${shapeFeatureProps.key}-polygon`}
                color="#ffbb00"
                positions={inscribedPolygon.layer}
              />
            )}
          </>
        )
        break
      default:
        console.error("Unhandled JSON shapeFeature", shapeFeature)
        renderedShape = <div />
    }
  }
  return renderedShape
}

export default ShapeFeature
